import GradientAlert from "./GradientAlert";

export default GradientAlert;
